<template>
  <div class="pros-questions overflow-x-hide overflow-y-hide">
    <div class="container">
      <div class="row">
        <!-- - Page conetnt left - Start -->
        <div id="page-left" class="col-md-11 no-padding container-width">
          <!-- - Page Header -->
          <headerlogo :page-type="'2'" @slide-menu="slideMenu" />
          <!-- - Questions content - Start -->
          <div
            id="main-body"
            class="row no-padding main-body h-100 no-margin"
            :style="{ height: windowHeight }"
          >
            <div
              id="main-body-sec"
              class="main-body-sec"
              :style="{ height: windowHeightInside }"
              style="width: 100%"
              @scroll="scrollSecDiv"
            >
              <div
                v-show="showGradient"
                id="main-body-before"
                class="main-body-before"
              />

              <div
                id="main-body-sec-qustns"
                class="row col-sm-12 col-md-12 my-auto no-margin unset-padding"
              >
                <div class="row text-container col-xl-12 no-margin no-padding">
                  <!-- Que.Group info - Start -->
                  <div
                    id="question-grp-info"
                    class="col-sm-12 col-md-3 flex-container no-padding question-grp-info"
                  >
                    <div
                      v-if="currQuestionGroupIndex === 0 || null"
                      class="text-title"
                    >
                      {{ getUiText("app-prospect-questions-heading-1") }}
                    </div>
                    <div
                      v-if="currQuestionGroupInfo || null"
                      class="text-subtitle"
                    >
                      <p class="text-subtitle-line-1">
                        {{ currQuestionGroupInfo.message }}
                      </p>
                      <p class="text-subtitle-line-2">
                        {{ currQuestionGroupInfo.guidance }}
                      </p>
                    </div>
                  </div>
                  <!-- Que.Group info - End -->

                  <!-- Grp. Ques - Start -->
                  <div
                    id="input-container"
                    class="col-sm-12 offset-md-1 col-md-7 large-container unset-padding input-container flex-container"
                    :style="{ height: rightContentHeight }"
                    style="border: 0px solid red"
                  >
                    <div
                      id="input-container-before"
                      class="input-container-before"
                      :style="inputBeforeGradient"
                    />
                    <div
                      id="inactive-qstns-block"
                      class="inactive-qstns-block"
                      :style="{ 'min-height': inactiveMinHeight }"
                    >
                      <div
                        v-if="
                          (currQuestionGroupInfo.prospect_questions &&
                            currQuestionGroupInfo.prospect_questions.length >
                              1) ||
                          null
                        "
                      >
                        <div
                          v-for="(item, itemIndex) in currGroupQuestions"
                          :key="itemIndex"
                        >
                          <TextBlock
                            v-if="item.isAnswered || null"
                            :info="item"
                            :is-mobile-device="isMobileDevice"
                          />
                          <div
                            v-if="
                              (item.isAnswered &&
                                (currQuestionInfo.id ||
                                  itemIndex < currGroupQuestions.length - 1)) ||
                              null
                            "
                            class="questions-seperator"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="currQuestionInfo.id || null"
                      id="currQstnDiv"
                      class="question-info"
                    >
                      <!-- Ques. Guidance  -- Start -->
                      <div
                        v-if="canShowGuidance || null"
                        class="guidance-text-info"
                      >
                        <div
                          id="popper-content"
                          :class="
                            canShowGuidance
                              ? 'popover fade show bs-popover-left'
                              : 'hide'
                          "
                        >
                          <div
                            class="guidance-close-panel"
                            @click="closeGuidanceInfo"
                          >
                            <span class="guidance-close-text">{{
                              getUiText("app-prospect-questions-close-info-1")
                            }}</span>
                            <span
                              ><img
                                class="tw-mr-[2px]"
                                src="@/assets/img/close.svg"
                            /></span>
                          </div>
                          <div class="guidance-text-block">
                            <span class="guidance-text-content">{{
                              guidanceText
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- Ques. Guidance  -- End -->

                      <div
                        v-if="
                          currQuestionInfo.question_display_type === 'text' ||
                          null
                        "
                      >
                        <InputText
                          ref="INPUT_TEXT"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type ===
                          'multi-tile'
                        "
                      >
                        <MultiTile
                          ref="MULTI_TILE"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type ===
                          'single-list-1-search'
                        "
                      >
                        <DropdownSingleLevel
                          ref="SELECT_SINGLE_LEVEL"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                          :enable-search="true"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type ===
                          'multi-list-1-search'
                        "
                      >
                        <SelectSingleLevelMultipleItems
                          ref="SELECT_SINGLE_LEVEL_MULTIPLE"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                          :enable-search="true"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type ===
                          'single-bubble'
                        "
                      >
                        <BubbleTile
                          ref="BUBBLE_TILE"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                          :is-single-select="true"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type ===
                          'single-list-1'
                        "
                      >
                        <DropdownSingleLevel
                          ref="SELECT_SINGLE_LEVEL"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                          :enable-search="false"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type ===
                          'single-list-2'
                        "
                      >
                        <DropdownDoubleLevel
                          ref="SELECT_SINGLE_LEVEL_2"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                          :enable-search="false"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type ===
                          'multi-level-multi-search'
                        "
                      >
                        <SelectMultiLevel
                          ref="SELECT_MULTI_LEVEL"
                          :key="currQuestionInfo.id"
                          :info="currQuestionInfo"
                          :enable-search="true"
                        />
                      </div>
                      <div
                        v-else-if="
                          currQuestionInfo.question_display_type !== ''
                        "
                      >
                        It is : {{ currQuestionInfo.question_display_type }}
                      </div>
                    </div>

                    <div
                      v-show="inputBottomGradient"
                      class="input-container-after"
                    />
                  </div>
                  <!-- Grp. Ques - End -->
                </div>
              </div>
              <div v-show="showBottomGradient" class="main-body-after" />
            </div>

            <div id="mb-button-view" class="mb-button-view">
              <button type="button" class="btn great-btn" @click="setNext">
                {{ getUiText("app-nav-button-next-1") }}
              </button>
            </div>
          </div>
          <!-- - Questions content - End -->

          <!-- - Que.Footer - Start -->
          <div class="row footer no-margin">
            <div
              class="col-7 col-md-4 footer-panel-container no-padding progress-status-panel"
            >
              <!-- Circled Progress bar - Start -->
              <radial-progress-bar
                class="d-inline"
                :total-steps="totalQuestionGroups"
                :completed-steps="currQuestionGroupIndex + 1"
              />
              <!-- Circled Progress bar - End -->

              <!-- Sections count - Start -->
              <div class="footer-text">
                {{ getUiText("app-prospect-questions-progress-section-1") }}
                {{ currQuestionGroupIndex + 1 }}
                {{ getUiText("app-prospect-questions-progress-of-1") }}
                {{ totalQuestionGroups }}
              </div>
              <!-- Sections count - End -->
            </div>

            <!-- - Que.Controllers - Start -->
            <div
              v-if="!hideNextPanel || null"
              class="col-sm-12 col-md-7 no-padding buttons-panel"
            >
              <div>
                <button type="button" class="btn great-btn" @click="setNext">
                  {{ getUiText("app-nav-button-next-1") }}
                </button>
              </div>
              <div class="enter-text enter-lg">
                <span class="enter-text">{{
                  getUiText("app-nav-press-enter-1")
                }}</span>
                <span class="enter-icon"
                  ><img src="@/assets/enter_icon.svg"
                /></span>
              </div>
            </div>
            <!-- - Que.Controllers - End -->

            <!-- Prev & Next Buttons for mobile view - Start -->
            <div class="mb-nav-icons col-3 no-padding d-block d-md-none">
              <span
                v-if="currQuestionGroupIndex > 0 || null"
                class="mb-prev-icon"
                @click="onClickPrevious"
              >
                <img src="@/assets/img/previous-icon.svg" />
              </span>
              <span
                v-if="currQuestionGroupIndex < totalQuestionGroups - 1 || null"
                class="mb-next-icon"
                @click="onClickSkip"
              >
                <img src="@/assets/img/next-icon.svg" />
              </span>
            </div>
            <!-- Prev & Next Buttons for mobile view - End -->
          </div>
          <!-- - Que.Footer - End -->
        </div>
        <!-- - Page conetnt left - Start -->

        <!-- - Page Menu - Right - Start -->
        <div
          class="col-md-1 no-padding menu-width lg-menu-view tw-relative"
          :style="{ 'min-height': dyn_height }"
        >
          <div class="right-menu">
            <div class="elipse-menu" @click="slideMenu">
              <span>
                <img src="@/assets/img/elipse_menu.svg" />
              </span>
            </div>
          </div>

          <div
            class="question-icon-panel"
            data-toggle="popover"
            title=""
            data-content=""
            data-placement="left"
            :style="{
              'margin-top': questionIconTop,
              display: canShowGuidanceIcon ? 'block' : 'none',
            }"
            @click="showGuidance"
          >
            <img class="question-icon" src="@/assets/img/question-icon.svg" />
          </div>

          <div class="menu-nav-icons">
            <div
              v-if="currQuestionGroupIndex > 0 || null"
              :class="
                isTouchDevice ? 'show-prev-image-no-hover' : 'show-prev-image'
              "
            >
              <img
                class="prev-img"
                src="@/assets/img/previous-icon.svg"
                @click="onClickPrevious"
              />

              <div
                v-if="!isTouchDevice || null"
                class="overlay"
                @click="onClickPrevious"
              >
                <!-- <img class="previous-image" src="@/assets/img/previous-img.svg"/> -->
                <div class="previous-img previous-button">
                  <img src="@/assets/img/previous-arrow.svg" />
                  {{ getUiText("app-prospect-questions-button-previous-1") }}
                </div>
              </div>
            </div>
            <div class="show-next-image" @click="onClickSkip">
              <img
                v-show="currQuestionGroupIndex < totalQuestionGroups - 1"
                class="next-icon"
                src="@/assets/img/next-icon.svg"
              />
            </div>
          </div>
        </div>
        <!-- - Page Menu - Right - End -->

        <!-- - Page Menu Content - Start -->

        <sidebar
          :show-menu="showMenu"
          @my-response="myResponse"
          @create-account="createAccount"
          @close-menu="closeMenu"
        />
        <!-- - Page Menu Content - End -->
      </div>

      <!-- Hidden Buttons for modals -->
      <button
        id="feedbackModalStart"
        type="button"
        class="btn btn-primary display-none"
        data-bs-toggle="modal"
        data-bs-target="#feedbackModal"
      >
        Feedback Modal Open
      </button>
    </div>

    <errorhandler
      v-if="showProspectCallbackError || null"
      :prospect-callback-error-msg="prospectCallbackErrorMsg"
      @reset-show-prospect-callback-error="resetShowProspectCallbackError"
    />

    <!-- Feedback & feature modal -- Start -->
    <div
      id="feedbackModal"
      class="modal fade feedback-form"
      data-bs-backdrop="false"
    >
      <div
        v-show="isFeedbackModalOpened"
        role="dialog"
        v-bind="$attrs"
        class="v-modal"
        style="background: rgba(239, 240, 241, 0.5); top: 0px"
        @click="feedbackModalNext"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content" @click.stop>
            <div class="modal-header">
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="feedbackModalNext"
              >
                <img src="@/assets/img/close.svg" />
              </button>
            </div>
            <div class="modal-body">
              <p class="modal-heading">
                {{ getUiText("app-prospect-questions-feedback-thanks-text")
                }}<span v-if="feedbackModalInfo.name !== '' || null"
                  >, {{ feedbackModalInfo.name }} </span
                >!
              </p>
              <div class="modal-text">
                <div class="text-line-1">
                  {{ feedbackModalInfo.fd_message }}
                </div>
                <div class="text-line-2">
                  {{ feedbackModalInfo.fr_message }}
                </div>
              </div>

              <div class="btn-container">
                <button
                  type="button"
                  class="btn great-btn"
                  @click="feedbackModalNext"
                >
                  {{ getUiText("app-prospect-questions-feedback-great-text") }}
                </button>
                <div v-if="!isTouchDevice || null" class="enter-text">
                  <span class="enter-text">{{
                    getUiText("app-nav-press-enter-1")
                  }}</span>
                  <span class="enter-icon">
                    <img src="@/assets/enter_icon.svg" />
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="feedbackModalInfo.footer_message !== '' || null"
              class="modal-footer"
            >
              <div class="modal-footer-text">
                {{ feedbackModalInfo.footer_message }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Feedback & feature modal -- End -->
  </div>
</template>
<script lang="ts">
import { Component, Watch } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import InputText from "@/components/prospect/prospectQuestions/componentTypes/inputText.vue";
import TextBlock from "@/components/prospect/prospectQuestions/componentTypes/textBlock.vue";
import DropdownSingleLevel from "@/components/prospect/prospectQuestions/componentTypes/dropDownSingleLevel.vue";
import MultiTile from "@/components/prospect/prospectQuestions/componentTypes/multiTile.vue";
import SelectSingleLevelMultipleItems from "@/components/prospect/prospectQuestions/componentTypes/selectSingleLevelMultipleItems.vue";
import BubbleTile from "@/components/prospect/prospectQuestions/componentTypes/bubbleTile.vue";
import RadialProgressBar from "@/components/prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import DropdownDoubleLevel from "@/components/prospect/prospectQuestions/componentTypes/dropDownDoubleLevel.vue";
import SelectMultiLevel from "@/components/prospect/prospectQuestions/componentTypes/selectMultiLevel.vue";
import HeaderLogo from "@/components/common/headerLogo.vue";
import SideBar from "@/components/common/prospectQuestionsMenu.vue";

// import { namespace } from "vuex-class";
import ProspectService from "@/services/prospect/prospectService";
import $ from "jquery";
import _ from "underscore";
import { load } from "recaptcha-v3";
import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils from "@/utils/utilities";
import store from "@/store";
import EventEmitter from "@/utils/eventEmitter";
import { localStorageBoolean, localStorageKey } from "@/utils/constants";
import { Modal } from "bootstrap";

// const ProspectQuestionsModule = namespace("ProspectQuestions");
// const LanguagePickerModule = namespace("LanguagePicker");

@Component({
  components: {
    InputText,
    TextBlock,
    DropdownSingleLevel,
    MultiTile,
    SelectSingleLevelMultipleItems,
    BubbleTile,
    RadialProgressBar,
    DropdownDoubleLevel,
    SelectMultiLevel,
    headerlogo: HeaderLogo,
    sidebar: SideBar,
    errorhandler,
  },
})
export default class ProspectQuestions extends Vue {
  windowHeight = "";
  rightContentHeight = "";
  dyn_height = "0";
  showMenu = false;
  questionIconTop = "-100px";
  questionIconDisplay = "block";
  canShowGuidance = false;
  guidanceText = "";
  progressValue = 0;
  inactiveMinHeight = "unset";
  canShowGuidanceIcon = false;
  feedbackModalInfo: object = {};
  isFeedbackModalOpened = false;
  isDeviceSmall = false;
  isLoading = false;
  isMobileDevice = false;
  windowHeightInside = "";
  showGradient = false;
  backgroundHeader = "";
  deviceWithGradient = false;
  potraitMode = true;
  inputBeforeGradient = "background: unset;";
  isTouchDevice = false;
  hideNextPanel = false;
  inputAfterGradient = "background: unset;";
  showBottomGradient = true;
  inputBottomGradient = true;
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";
  feedbackModalInstance: any = null;

  get currQuestionGroupIndex() {
    return store.state.ProspectQuestions.currQuestionGroupIndex;
  }

  get currQuestionIndex() {
    return store.state.ProspectQuestions.currQuestionIndex;
  }

  get currQuestionGroupInfo() {
    return store.state.ProspectQuestions.currQuestionGroupInfo;
  }

  get currQuestionInfo() {
    return store.state.ProspectQuestions.currQuestionInfo;
  }

  get currQuestionAnswer() {
    return store.state.ProspectQuestions.currQuestionAnswer;
  }

  get currGroupQuestions() {
    return store.state.ProspectQuestions.currGroupQuestions;
  }

  get editQuestionId() {
    return store.state.ProspectQuestions.editQuestionId;
  }

  get totalQuestionGroups() {
    return store.state.ProspectQuestions.totalQuestionGroups;
  }

  get prospectQuestionGroups() {
    return store.state.ProspectQuestions.prospectQuestionGroups;
  }

  get isAnswerUpdated() {
    return store.state.ProspectQuestions.isAnswerUpdated;
  }

  get isAnswerEmpty() {
    return store.state.ProspectQuestions.isAnswerEmpty;
  }

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  @Watch("currQuestionGroupIndex")
  onChangeQGIndex() {
    this.calcProgressVal();
  }
  @Watch("progressValue")
  onProgressValChange() {
    this.onChangeProgressVal();
  }

  @Watch("currGroupQuestions")
  onChnagesQuestions() {
    if (window.innerWidth > 1023) {
      this.setInactiveMinHeight();
    }
  }

  @Watch("currQuestionInfo")
  async onChangeCurrQuestion() {
    if (this.currQuestionInfo && this.currQuestionInfo.guidance) {
      this.canShowGuidanceIcon = true;
    } else {
      this.canShowGuidanceIcon = false;
    }
    await this.setModalBodySecPadding();
    this.setGuidancePlacement();
  }

  @Watch("isDeviceSmall")
  onChangeWindowSizeForScroll() {
    this.changeScrollListeners();
  }

  created() {
    sessionStorage.setItem("currQuestionGroupIndex", "");
    this.getQuestionsData();

    const body = $("body");
    if (!body.hasClass("page-bg-gradient-1")) {
      body.addClass("page-bg-gradient-1 page-shadow-2");
    }

    EventEmitter.on("APP_INPUT_POSITION", (() => {
      //this.inputPositionFromTop(val);
    }) as any);

    EventEmitter?.on("APP_PROSPECT_QUESTION_EDIT", ((val: string) => {
      this.onClickEditQuestionFromChild(val);
    }) as any);

    EventEmitter?.on("APP_NEXT_PANEL_VISIBITITY", ((val: boolean) => {
      this.setNexPanelVisibility(val);
    }) as any);

    EventEmitter?.on("APP_SCROLL_BOTTOM_CUSTOM", (val: any) => {
      this.scrollBottomToCustom(val);
    });
  }
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onWindowResize);
      window.addEventListener("keyup", this.onWindowKeyUp);
      this.onWindowResize();
      this.changeScrollListeners();
      setTimeout(async () => {
        await this.onWindowResize();
        this.changeScrollListeners();
      }, 0);

      this.calcProgressVal();
    });
    this.setLanguages();

    document.body.classList.add("custom-body-style");
    const feedbackModal = document.getElementById("feedbackModal");
    if (feedbackModal) {
      this.feedbackModalInstance = new Modal(feedbackModal);
      feedbackModal.addEventListener("show.bs.modal", this.onOpenFeedbackModal);
      feedbackModal.addEventListener(
        "hidden.bs.modal",
        this.onCloseFeedbackModal,
      );
    }
  }

  async setLanguages() {
    if (
      localStorage.getItem(localStorageKey.languagesData) == null ||
      localStorage.getItem(localStorageKey.languageList) == null
    ) {
      await Utils.getV3Recaptcha().then(
        async (finalKey: any) => {
          localStorage.removeItem("csrfReloadDone");
          const captchKey = finalKey;
          const recaptcha = await load(`${captchKey}`, {
            autoHideBadge: true,
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguages", token);
          });
          recaptcha.execute("submit").then((token) => {
            this.$store.dispatch("LanguagePicker/setLanguageList", token);
          });
        },
        (error: any) => {
          if (
            error &&
            error.data &&
            error.data.error &&
            error.data.error.type
          ) {
            if (error.data.error.type === "exc_session_invalid-1") {
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(error.data.error),
              );
              this.$router.push({ path: "/" });
            } else {
              this.showErrorInfo(error.data.error);
            }
          } else if (error.data.message === "invalid csrf token") {
            if (localStorage.getItem("csrfReloadDone") == null) {
              localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
              this.$router.go(0);
            }
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data);
          }
        },
      );
    }
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  setIsDeviceHasTouch() {
    this.isTouchDevice = false;
    const isTouchable =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
    if (
      !isTouchable &&
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        navigator.userAgent.toLowerCase(),
      )
    ) {
      this.isTouchDevice = true;
    } else {
      this.isTouchDevice = isTouchable ? true : false;
    }
  }

  scrollSecDiv() {
    //show the gradient here
    if (this.deviceWithGradient) {
      this.showGradient = true;
      // this.showBottomGradient = true;

      this.backgroundHeader = "background-color: #ffffff;";
    }
  }

  async getQuestionsData() {
    if ((this.currQuestionGroupIndex as number) < 0) {
      const prospectService = new ProspectService();
      let data = { language: this.languageSelected };
      prospectService.getProspectQuestions(data).then(
        async (response: any) => {
          localStorage.removeItem("csrfReloadDone");
          if (
            response.data &&
            response.data.data &&
            response.data.data.prospect_question_groups
          ) {
            if (response.data.data.prospect_question_groups.length > 0) {
              sessionStorage.setItem(
                "questionsData",
                JSON.stringify(response.data.data),
              );
              await this.$store.dispatch(
                "ProspectQuestions/setProsQuesGroups",
                response.data.data.prospect_question_groups,
              );
              //if(this.currQuestionGroupIndex as number < 0){
              await this.$store.dispatch("ProspectQuestions/checkAndSetNext");
              this.scrollDivToTop();
              //}
              this.calcProgressVal();
            } else {
              let errorObject = {
                message: this.getUiText("app-prospect-error-no-questions"),
              };
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(errorObject),
              );
              this.$router.push({ path: "/" });
            }
          }
        },
        (error: any) => {
          if (
            error &&
            error.data &&
            error.data.error &&
            error.data.error.type
          ) {
            if (error.data.error.type === "exc_session_invalid-1") {
              sessionStorage.setItem(
                "prospectCallbackErrorInfo",
                JSON.stringify(error.data.error),
              );
              this.$router.push({ path: "/" });
            } else {
              this.showErrorInfo(error.data.error);
            }
          } else if (error.data.message === "invalid csrf token") {
            if (localStorage.getItem("csrfReloadDone") == null) {
              localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
              this.$router.go(0);
            }
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data);
          }
        },
      );
    } else {
      await this.scrollDivToTop();
      this.calcProgressVal();
    }
  }

  questionsPanelScroll(e: any) {
    let { scrollTop, clientHeight, scrollHeight }: any = e.target;
    if (scrollTop > 0) {
      this.showGradient = true;
      this.inputBeforeGradient = " ";
    } else {
      this.showGradient = false;
      this.inputBeforeGradient = "background: unset;";
    }
    if (scrollTop + clientHeight === scrollHeight) {
      this.inputAfterGradient = "background: unset;";
      //this.showBottomGradient = false;
      //this.inputBottomGradient=false;
    } else {
      this.inputAfterGradient = " ";
      //this.showBottomGradient=true;
      // this.inputBottomGradient=true;
    }

    if (this.currQuestionInfo.guidance && !this.isMobileDevice) {
      const currQustnDivId = $("#currQstnDiv").find(".comp-start").attr("id");
      if (currQustnDivId) {
        const currQustDivPost: any = (
          document.getElementById("" + currQustnDivId) as any
        ).getBoundingClientRect();

        const v1: any = this.questionIconTop.replace("px", "");
        let v2: any = currQustDivPost.top;

        if ((v1 >= v2 && v1 - v2 <= 100) || (v2 >= v1 && v2 - v1 < 100)) {
          this.canShowGuidanceIcon = true;
        } else {
          this.canShowGuidanceIcon = false;
        }
      }
    }
  }

  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }

  setInactiveMinHeight() {
    if (window.innerWidth > 3839) {
      if (this.currGroupQuestions.length === 0) {
        this.inactiveMinHeight = "15%";
      } else {
        this.inactiveMinHeight = "25%";
      }
    } else if (window.innerWidth > 1023) {
      if (this.currGroupQuestions.length === 0) {
        this.inactiveMinHeight = "10%";
      } else {
        this.inactiveMinHeight = "unset";
      }
    } else {
      this.inactiveMinHeight = "unset";
    }
  }
  calcProgressVal() {
    if (this.currQuestionGroupIndex >= 0 && this.totalQuestionGroups > 0) {
      this.progressValue =
        ((this.currQuestionGroupIndex + 1) / this.totalQuestionGroups) * 100;
      if (("" + this.progressValue).indexOf(".") > 0) {
        this.progressValue = Math.ceil(this.progressValue);
      }
    } else {
      this.progressValue = 0;
    }
  }
  onWindowResize() {
    this.dyn_height = (window.innerHeight + "px !important") as string;
    this.isMobileDevice = false;
    if (window.innerWidth <= 1024) {
      let calcHeight: any = "";
      // let insideHeight: any = "";
      if (window.innerHeight < 500) {
        calcHeight = window.innerHeight - 120;
        // insideHeight = (window.innerHeight / 4) * 2.3;
        this.rightContentHeight = "unset !important" as string;
        if (window.innerWidth < 1024 && window.innerWidth >= 812) {
          calcHeight = window.innerHeight - 120;
          // insideHeight = (window.innerHeight / 4) * 2.3;
          this.rightContentHeight = (calcHeight + "px !important") as string;
          this.isDeviceSmall = true;
          this.potraitMode = false;
          this.changeScrollListeners();
        } else {
          this.isDeviceSmall = false;
        }
      } else if (window.innerWidth < 768) {
        this.potraitMode = true;
        calcHeight = window.innerHeight - 156;
        // insideHeight = (window.innerHeight / 4) * 2.5;
        this.rightContentHeight = "unset !important" as string;
        this.isMobileDevice = true;
        this.isDeviceSmall = true;
      } else {
        if (window.innerWidth < window.innerHeight) {
          this.potraitMode = true;
          calcHeight = window.innerHeight - 245;
          // insideHeight = (window.innerHeight / 4) * 2.7;
          this.rightContentHeight = "unset px !important" as string;
          this.changeScrollListeners();
        } else {
          calcHeight = window.innerHeight - 200;
          this.rightContentHeight = (calcHeight + "px !important") as string;
          this.potraitMode = false;
          this.changeScrollListeners();
        }
        this.isDeviceSmall = true;
      }
      this.windowHeightInside = (calcHeight - 50 + "px !important") as string;
      this.windowHeight = (calcHeight + "px !important") as string;
    } else {
      if (
        window.innerWidth < window.innerHeight &&
        window.innerHeight > 1000 &&
        window.innerWidth > 1000
      ) {
        const calcHeight_l2 = (window.innerHeight / 3) * 2;
        this.windowHeight = (calcHeight_l2 - 100 + "px !important") as string;
        this.rightContentHeight = "unset !important" as string;
      } else {
        if (window.innerWidth >= 3840) {
          this.windowHeight = (window.innerHeight -
            250 +
            "px !important") as string;
          this.rightContentHeight = (window.innerHeight -
            250 +
            "px !important") as string;
        } else {
          this.windowHeight = (window.innerHeight -
            200 +
            "px !important") as string;
          this.rightContentHeight = (window.innerHeight -
            200 +
            "px !important") as string;
        }
      }

      if (this.potraitMode == false) {
        this.isDeviceSmall = true;
      } else {
        this.isDeviceSmall = false;
      }
    }

    this.deviceWithGradient = window.innerWidth < 769;

    //For no gradient, get the original header colors.
    if (!this.deviceWithGradient) {
      this.backgroundHeader = "";
    }
    this.setIsDeviceHasTouch();
  }
  changeScrollListeners() {
    const mainDiv: any = document.getElementById("main-body-sec");
    const contentDiv: any = document.getElementById("input-container");
    if (this.isDeviceSmall) {
      if (this.potraitMode === true) {
        contentDiv &&
          contentDiv.removeEventListener("scroll", this.questionsPanelScroll);
        mainDiv &&
          mainDiv.addEventListener("scroll", this.questionsPanelScroll);
      } else {
        mainDiv &&
          mainDiv.removeEventListener("scroll", this.questionsPanelScroll);
        contentDiv &&
          contentDiv.addEventListener("scroll", this.questionsPanelScroll);
      }
    } else {
      mainDiv &&
        mainDiv.removeEventListener("scroll", this.questionsPanelScroll);
      contentDiv &&
        contentDiv.addEventListener("scroll", this.questionsPanelScroll);
    }
  }
  closeMenu() {
    this.showMenu = false;
    this.updateMenuUI();
  }
  slideMenu() {
    this.showMenu = true;
    this.updateMenuUI();
  }
  updateMenuUI() {
    if (this.showMenu) {
      // Adding time delay to show fade to left part of page as same time of transition of menu.
      setTimeout(() => {
        if (!$("#page-left").hasClass("opacity-2")) {
          $("#page-left").addClass("opacity-2 white-bg");
        }
      }, 200);
    } else {
      if ($("#page-left").hasClass("opacity-2")) {
        $("#page-left").removeClass("opacity-2 white-bg");
      }
    }
  }
  onWindowKeyUp(e: any) {
    if (!this.isLoading && e && e.keyCode && e.keyCode == 13) {
      if (this.isFeedbackModalOpened) {
        this.isLoading = true;
        this.feedbackModalNext();
      } else {
        this.setNext();
      }
    } else {
      this.resetFeedbackModalInfo();
    }
  }
  async saveCurrentQuestionAnswer(callFrom: string) {
    let ansVal: any = "";
    if (this.currQuestionInfo.question_display_type === "text") {
      const textChild: any = this.$refs.INPUT_TEXT;
      ansVal =
        this.$refs.INPUT_TEXT && textChild.input_val ? textChild.input_val : "";
      if (ansVal) {
        textChild.input_val = "";
      }
    } else if (this.currQuestionInfo.question_display_type === "multi-tile") {
      const tileCont: any = this.$refs.MULTI_TILE;
      let selList: any = [];
      if (tileCont && tileCont.list && tileCont.list.length > 0) {
        for (let p = 0; p < tileCont.list.length; p++) {
          if (tileCont.list[p].isSelected) {
            selList.push(tileCont.list[p].id);
          }
        }
        ansVal = selList;
      }
    } else if (
      this.currQuestionInfo.question_display_type === "single-list-1-search"
    ) {
      const selectVal: any = this.$refs.SELECT_SINGLE_LEVEL;
      ansVal =
        selectVal && selectVal.selectedItem
          ? selectVal.selectedItem.id
            ? selectVal.selectedItem.id
            : ""
          : "";
      if (ansVal) {
        //selectVal.selectedItem = {};
      }
    } else if (
      this.currQuestionInfo.question_display_type === "single-list-1"
    ) {
      const selectVal: any = this.$refs.SELECT_SINGLE_LEVEL;
      ansVal =
        selectVal && selectVal.selectedItem
          ? selectVal.selectedItem.id
            ? selectVal.selectedItem.id
            : ""
          : "";
    } else if (
      this.currQuestionInfo.question_display_type === "multi-list-1-search"
    ) {
      const selectVal: any = this.$refs.SELECT_SINGLE_LEVEL_MULTIPLE;
      if (selectVal.selectedItems && selectVal.selectedItems.length > 0) {
        ansVal = _.map(selectVal.selectedItems, (r: any) => {
          return r.id;
        });
      }
    } else if (
      this.currQuestionInfo.question_display_type === "single-bubble"
    ) {
      const tileCont: any = this.$refs.BUBBLE_TILE;
      let selList: any = [];
      if (tileCont && tileCont.list && tileCont.list.length > 0) {
        for (let p = 0; p < tileCont.list.length; p++) {
          if (tileCont.list[p].isSelected) {
            selList.push(tileCont.list[p].id);
          }
        }
        ansVal = selList;
      }
    } else if (
      this.currQuestionInfo.question_display_type === "single-list-2"
    ) {
      const selectVal: any = this.$refs.SELECT_SINGLE_LEVEL_2;
      ansVal =
        selectVal && selectVal.selectedItem
          ? selectVal.selectedAmount.id
            ? selectVal.selectedAmount.id
            : ""
          : "";
    } else if (
      this.currQuestionInfo.question_display_type === "multi-level-multi-search"
    ) {
      const selectVals: any = this.$refs.SELECT_MULTI_LEVEL;
      if (selectVals.selectedItems && selectVals.selectedItems.length > 0) {
        ansVal = _.map(selectVals.selectedItems, (r: any) => {
          return r.id;
        });
      }
    } else {
      ansVal = "";
    }
    await this.$store.dispatch("ProspectQuestions/setQuestionAnswer", {
      ans: ansVal,
      callFrom: callFrom,
    });
  }
  async setNext() {
    this.canShowGuidance = false;
    this.guidanceText = "";
    this.canShowGuidanceIcon = false;

    await this.saveCurrentQuestionAnswer("NEXT");
    this.$nextTick(async () => {
      if (
        this.currQuestionGroupInfo &&
        this.currQuestionGroupInfo.prospect_questions &&
        this.currQuestionGroupInfo.prospect_questions.length - 1 ==
          this.currQuestionIndex
      ) {
        if (
          this.isAnswerUpdated &&
          this.currQuestionIndex >= 0 &&
          this.currQuestionGroupInfo
        ) {
          let saveGrpObj: any = {};
          saveGrpObj.name = this.currQuestionGroupInfo.id;
          saveGrpObj.prospect_questions = [];
          let grpQstns: any[] = [];
          for (let qs of this.currQuestionGroupInfo.prospect_questions) {
            let qstnObj: any = {};
            qstnObj.name = qs.id;
            qstnObj.values = qs.values;
            grpQstns.push(qstnObj);
          }
          saveGrpObj.prospect_questions = grpQstns;
          await this.$store
            .dispatch("ProspectQuestions/saveCurrGroupInfo", {
              prospect_question_group: saveGrpObj,
            })
            .then(
              async (resp: any) => {
                localStorage.removeItem("csrfReloadDone");
                if (resp && resp.data && resp.data.message) {
                  if (resp.data.message.toLowerCase() === "success") {
                    if (
                      !this.isAnswerEmpty &&
                      resp.data.data &&
                      Object.keys(resp.data.data).length > 0
                    ) {
                      this.setFeedbackInfo(resp.data.data);
                    } else {
                      if (
                        this.totalQuestionGroups - 1 ==
                        this.currQuestionGroupIndex
                      ) {
                        this.myResponse();
                      } else {
                        await this.$store.dispatch(
                          "ProspectQuestions/checkAndSetNext",
                        );
                        this.scrollDivToTop();
                      }
                    }
                  }
                }
              },
              (error: any) => {
                if (
                  error &&
                  error.data &&
                  error.data.error &&
                  error.data.error.type
                ) {
                  if (error.data.error.type === "exc_session_invalid-1") {
                    sessionStorage.setItem(
                      "prospectCallbackErrorInfo",
                      JSON.stringify(error.data.error),
                    );
                    this.$router.push({ path: "/" });
                  } else {
                    this.showErrorInfo(error.data.error);
                  }
                } else if (error.data.message === "invalid csrf token") {
                  if (localStorage.getItem("csrfReloadDone") == null) {
                    localStorage.setItem(
                      "csrfReloadDone",
                      localStorageBoolean.true,
                    );
                    this.$router.go(0);
                  }
                  sessionStorage.setItem(
                    "prospectCallbackErrorInfo",
                    JSON.stringify(error.data),
                  );
                  this.$router.push({ path: "/" });
                } else {
                  this.showErrorInfo(error.data);
                }
              },
            );
        } else {
          if (this.totalQuestionGroups - 1 == this.currQuestionGroupIndex) {
            this.myResponse();
          } else {
            await this.$store.dispatch("ProspectQuestions/checkAndSetNext");
            this.scrollDivToTop();
          }
        }
      } else if (this.currQuestionIndex < 0) {
        await this.$store.dispatch("ProspectQuestions/setNextQuestionGroup");
      } else {
        await this.$store.dispatch("ProspectQuestions/checkAndSetNext");
        this.scrollToBottomOfPanel();
      }
    });
  }
  setModalBodySecPadding() {
    const isLargeView = $("#mb-button-view").is(":visible") ? false : true;

    if (
      this.currQuestionInfo &&
      this.currQuestionInfo.id &&
      this.currQuestionIndex >= 0 &&
      this.currQuestionGroupInfo.prospect_questions &&
      this.currQuestionGroupInfo.prospect_questions.length > 0
    ) {
      if (isLargeView) {
        $("#input-container").addClass("padding-bottom-10");
        $("#input-container").removeClass("unset-padding");
      } else {
        if (window.innerHeight > 767) {
          $("#main-body-sec-qustns").addClass("padding-bottom-20");
        } else {
          $("#main-body-sec-qustns").addClass("padding-bottom-60");
        }
        $("#main-body-sec-qustns").removeClass("unset-padding");
      }
    } else {
      if (isLargeView) {
        if ($("#input-container").hasClass("padding-bottom-10")) {
          $("#input-container").removeClass("padding-bottom-10");
          $("#input-container").addClass("unset-padding");
        }
      } else {
        if ($("#main-body-sec-qustns").hasClass("padding-bottom-20")) {
          $("#main-body-sec-qustns").removeClass("padding-bottom-20");
        } else if ($("#main-body-sec-qustns").hasClass("padding-bottom-60")) {
          $("#main-body-sec-qustns").removeClass("padding-bottom-60");
        }

        $("#main-body-sec-qustns").addClass("unset-padding");
      }
    }
  }
  scrollToBottomOfPanel() {
    setTimeout(() => {
      const isLargeView = $("#mb-button-view").is(":visible") ? false : true;
      let elmnt: any = !isLargeView
        ? document.getElementById("main-body-sec")
        : document.getElementById("input-container");
      const elmntPost = isLargeView
        ? (
            document.getElementById("input-container-before") as any
          ).getBoundingClientRect()
        : (
            document.getElementById("main-body-sec") as any
          ).getBoundingClientRect();
      const currQustDivPost: any = (
        document.getElementById("currQstnDiv") as any
      ).getBoundingClientRect();

      if (elmnt && elmntPost && elmntPost.top && currQustDivPost.top) {
        if (currQustDivPost.top > 0) {
          $(elmnt).scrollTop(currQustDivPost.top - elmntPost.top);
        }
        this.setGuidancePlacement();
      }
    }, 100);
  }
  setGuidancePlacement() {
    if (this.currQuestionInfo.guidance) {
      const currQustnDivId = $("#currQstnDiv").find(".comp-start").attr("id");
      if (currQustnDivId) {
        const currQustDivPost: any = (
          document.getElementById("" + currQustnDivId) as any
        ).getBoundingClientRect();
        if (currQustDivPost && currQustDivPost.top) {
          this.inputPositionFromTop(currQustDivPost.top);
        }
      }
    }
  }
  scrollDivTobottom() {
    let elmnt = $("#mb-button-view").is(":visible")
      ? document.getElementById("mb-button-view")
      : document.getElementById("currQstnDiv"); // Active questions block or Next button.
    if (!elmnt || elmnt === undefined) {
      elmnt = document.getElementById("inactive-qstns-block"); // In-active questions block.
    }
    elmnt && elmnt.scrollIntoView({ behavior: "smooth", block: "end" }); // scroll to bottom
  }

  scrollDivToTop() {
    const isLargeView = $("#mb-button-view").is(":visible") ? false : true;
    if (isLargeView) {
      const mainElmntSec: any = document.getElementById("input-container");
      mainElmntSec && mainElmntSec.scrollBy(0, -300);
    } else {
      let elmnt: any = $("#mb-button-view").is(":visible")
        ? document.getElementById("question-grp-info")
        : document.getElementById("currQstnDiv");
      if (!elmnt || elmnt === undefined) {
        elmnt = document.getElementById("inactive-qstns-block"); // In-active questions block.
      }
      elmnt && elmnt.scrollIntoView({ behavior: "smooth", block: "start" }); // scroll to top
      setTimeout(async () => {
        if (this.deviceWithGradient) {
          this.showGradient = false;
          //this.showBottomGradient=false;
          this.backgroundHeader = "";
        }
      }, 200);
    }
  }

  async onClickSkip() {
    this.canShowGuidance = false;
    this.guidanceText = "";
    this.canShowGuidanceIcon = false;
    this.setNexPanelVisibility(false);

    await this.saveCurrentQuestionAnswer("SKIP");
    await this.$store.dispatch("ProspectQuestions/setNextQuestionGroup");
    this.scrollDivToTop();
  }
  async onClickPrevious() {
    this.canShowGuidance = false;
    this.guidanceText = "";
    this.canShowGuidanceIcon = false;
    this.setNexPanelVisibility(false);

    await this.$store.dispatch("ProspectQuestions/setPreviousQuestionGroup");
    this.$nextTick(() => {
      this.scrollDivToTop();
    });
  }

  async onClickEditQuestionFromChild(itemInfo: any) {
    this.canShowGuidance = false;
    this.guidanceText = "";
    this.canShowGuidanceIcon = false;

    //   To save current/active question answer.
    await this.saveCurrentQuestionAnswer("NEXT");

    await this.$store.dispatch(
      "ProspectQuestions/setEditQuestionInfo",
      itemInfo,
    );
    this.scrollDivTobottom();
  }
  inputPositionFromTop(val: any) {
    if (val > 0) {
      this.questionIconTop = (parseFloat(val) + 30 + "px") as string;
    }
  }
  showGuidance() {
    if (this.currQuestionInfo.guidance) {
      this.guidanceText = this.currQuestionInfo.guidance;
      this.canShowGuidance = !this.canShowGuidance;
    }
  }
  closeGuidanceInfo() {
    this.canShowGuidance = false;
  }

  onChangeProgressVal() {
    const context = this;
    $(".progress").each(function () {
      const perVal1 = (context.progressValue / 100) * 360;
      let perVal2 = ((context.progressValue - 50) / 100) * 360;
      const left = $(this).find(".progress-left .progress-bar");
      const right = $(this).find(".progress-right .progress-bar");

      if (context.progressValue > 0) {
        if (context.progressValue <= 50) {
          right.css("transform", "rotate(" + perVal1 + "deg)");
          if (perVal2 < 0) {
            left.css("transform", "rotate(0deg)");
          }
        } else {
          right.css("transform", "rotate(180deg)");
          if (perVal2 < 0) {
            perVal2 = 0;
          }
          left.css("transform", "rotate(" + perVal2 + "deg)");
        }
      }
    });
  }
  async setFeedbackInfo(data: any) {
    this.feedbackModalInfo = {};
    let feedbackInfo: any = { name: "", footer_message: "" };

    if (
      data &&
      data.feedback &&
      data.feedback !== undefined &&
      Object.keys(data.feedback).length > 0
    ) {
      feedbackInfo.fd_message = data.feedback.message
        ? data.feedback.message
        : "";
    }

    if (
      data &&
      data.feature &&
      data.feature !== undefined &&
      Object.keys(data.feature).length > 0
    ) {
      feedbackInfo.fr_message = data.feature.message;
    }

    const reqInfo = await this.getCustomRequiredInfo("names", "first_name");
    if (reqInfo && reqInfo !== undefined) {
      feedbackInfo.name = reqInfo;
    }

    if (feedbackInfo && Object.keys(feedbackInfo).length > 0) {
      this.feedbackModalInfo = Object.assign({}, feedbackInfo);

      if (this.feedbackModalInstance) {
        this.feedbackModalInstance.show();
      }
    }
  }
  getCustomRequiredInfo(value1: string, value2: string) {
    let finalVal = "";
    if (
      this.prospectQuestionGroups &&
      this.prospectQuestionGroups.length > 0 &&
      value1 &&
      value2
    ) {
      const val1Resp = this.prospectQuestionGroups.find(
        (l: any) => l.id === value1,
      );

      if (
        val1Resp &&
        val1Resp.prospect_questions &&
        val1Resp.prospect_questions.length > 0
      ) {
        const val2Resp = val1Resp.prospect_questions.find(
          (v: any) => v.id === value2,
        );
        if (val2Resp && val2Resp.values && val2Resp.values.length > 0) {
          if (typeof val2Resp.values === "string") {
            finalVal = val2Resp.values;
          } else {
            finalVal = val2Resp.values.join(",");
          }
        }
      }
    }
    return finalVal;
  }
  resetFeedbackModalInfo() {
    this.feedbackModalInstance?.hide();
  }
  async feedbackModalNext() {
    await this.resetFeedbackModalInfo();
    if (this.totalQuestionGroups - 1 == this.currQuestionGroupIndex) {
      this.myResponse();
    } else {
      await this.$store.dispatch("ProspectQuestions/checkAndSetNext");
      this.scrollDivToTop();
    }
  }
  onOpenFeedbackModal() {
    this.isFeedbackModalOpened = true;
  }
  onCloseFeedbackModal() {
    this.isLoading = false;
    this.isFeedbackModalOpened = false;
    this.feedbackModalInfo = {};
  }
  setNexPanelVisibility(val: boolean) {
    if (val) {
      this.hideNextPanel = true;
    } else {
      this.hideNextPanel = false;
    }
  }
  scrollBottomToCustom(val: any) {
    if (val) {
      setTimeout(() => {
        let scrollByVal = 200;
        let elmnt: any = "";
        const isLargeView = !$("#mb-button-view").is(":visible");
        if (isLargeView) {
          elmnt = document.getElementById("input-container");
        } else {
          scrollByVal = this.isMobileDevice ? 120 : scrollByVal;
          elmnt = document.getElementById("main-body-sec");
        }
        elmnt && elmnt.scrollBy(0, scrollByVal);
      }, 100);
    }
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }
  beforeUnmount() {
    document.body.classList.remove("custom-body-style");
    EventEmitter.off("APP_INPUT_POSITION");
    EventEmitter.off("APP_PROSPECT_QUESTION_EDIT");
    window.removeEventListener("keyup", this.onWindowKeyUp);

    const body = $("body");
    if (!body.hasClass("page-bg-gradient-1")) {
      body.removeClass("page-bg-gradient-1 page-shadow-2");
    }
  }
  myResponse() {
    if (this.currQuestionGroupIndex >= 0) {
      sessionStorage.setItem(
        "currQuestionGroupIndex",
        "" + this.currQuestionGroupIndex,
      );
      this.$router.push({ path: "/prospect/responses" });
    }
  }
  createAccount() {
    this.$router.push({ path: "/prospect/createaccount" });
  }
}
</script>
<style lang="scss" scoped>
.pros-questions {
  background: linear-gradient(
      0deg,
      rgba(238, 239, 240, 0.38) 50%,
      #ffffff 94.92%
    ),
    #ffffff;
}
.previous-button {
  background: transparent;
  border: 2px solid #0345bd;
  box-sizing: border-box;
  border-radius: 200px;
  font-family: Poppins;
  font-style: normal;
  padding: 10px 10px;
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #0345bd;

  img {
    margin-right: 5px;
  }
}
.width-280 {
  right: 0px;
}
.width-0 {
  right: -100%;
}
.elipse-menu {
  cursor: pointer;
  position: relative;
  text-align: center;
  top: 51px;
}
.elipse-menu-mb {
  cursor: pointer;
  position: static;
  text-align: center;
  top: unset;
}
.lg-menu-view {
  background: rgba(238, 239, 240, 0.3);
}
.menu-separation {
  border-bottom: 1px solid #ffffff;
  padding-top: 50px;
  opacity: 0.1;
}
.select-card {
  border: 3px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  padding: 15px;
  text-align: center;
  background: #ffffff;
  margin-right: 30px;
  max-width: 26%;
  color: #0345bd;
  font-size: 18px;
  display: inline-block;
  margin-bottom: 28px;
}
.select-card .show-icon {
  display: none;
}
.dropdown-button {
  width: 75%;

  background: #ffffff;
  border: 3px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  color: #0345bd;
  font-size: 32px;
  padding: 0px 15px;
}

.dropdown-toggle::after {
  display: none;
}
.industrials-dropdown-ques {
  color: #231f20;
  font-size: 13px;
  margin-top: 48px;
  font-weight: 500;
  margin-bottom: 22px;
}
.industrials-dropdown {
  font-size: 22px;
  width: 50%;
  height: 59px;
}
.tick-icon {
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
  padding: 3px;
  background: #ffffff;
}
.questions-logo {
  width: 210px;
  height: 47px;
  left: 40px;
  top: 36px;
  position: absolute;
}
.dropdown-options {
  margin-left: 20px;
}
.form-check-input {
  margin-top: 7px;
  margin-left: 0px;
}
.dropdown-item:active {
  background-color: #0345bd;
  color: #fff;
}
.dropdown-item:hover {
  background-color: #ffffff;
}
.select-band {
  border-radius: 200px;
}
.selected-band {
  border: 3px solid #0345bd;
}
.modal-header {
  border: none;
  justify-content: flex-end;
}
.modal-footer {
  background: linear-gradient(
    180deg,
    rgba(230, 230, 230, 0.38) 0%,
    #ffffff 58.06%
  );
}
.great-btn {
  background: #0345bd !important;
  box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
  border-radius: 26.9091px;
  color: white !important;
  font-size: 16px;
  padding: 5px 20px;
  width: unset;
  border: none;
}
.btn-container {
  margin-left: 0px;
  margin-right: 0px;
  display: flex;
  flex-direction: row;
}

.enter-text {
  font-size: 16px;
  padding: 10px 15px;
  color: #0345bd;
}
.modal-content {
  box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
  border-radius: 6px;
  border: none;
}
.modal-questions {
  color: #231f20;
  font-size: 14px;
  padding: 20px 0px;
  font-weight: 500;
}
.div-separator {
  border: 1px solid #b7b7b7;
  opacity: 0.3;
}
.modal-questions-heading {
  color: #231f20;
  font-size: 20px;
  font-weight: 500;
  display: inline-block;
}
.modal-questions:last-child {
  border: none;
}
.response-modal-heading {
  color: #0345bd;
  font-size: 26px;
  font-weight: 600;
}
.authentication-modal-heading {
  color: #0345bd;
  font-size: 25px;
  font-weight: 600;
}
.response-modal-edit {
  display: inline-block;
  float: right;
  font-size: 13px;
}
.account-modal-text {
  font-size: 15px;
  color: #231f20;
}
.password-text {
  color: #878787;
  font-size: 12px;
}
.password-contain {
  color: #231f20;
}
.account-modal {
  padding: 0px 40px 30px 40px;
}
.account-modal-footer {
  padding: 10px 40px;
  font-size: 12px;
}
.input-label-password {
  font-weight: 500;
  font-size: 12px;
  color: #231f20;
}
.password-input {
  border: none;
  font-size: 22px;
  border-left: 2px solid #b7b7b7;
  border-radius: unset;
}
.password-group > .form-control:focus {
  box-shadow: none !important;
}
.password-group input::placeholder {
  color: #b7b7b7;
}
.password-conditions {
  margin-left: 0px;
  margin-right: 0px;
}
.qr-code-container {
  background: #eeeff0;

  border: 1px solid #eeeff0;
  border-radius: 4px;
  padding: 10px;
}
.img-div {
  display: inline-block;
}
.img-text-box {
  display: inline-block;
  vertical-align: middle;
  padding-left: 30px;
}
.img-text {
  font-size: 12px;
}
.qr-text {
  font-size: 18px;
}
.password-left-conditions {
  margin-bottom: 0px;
}
.container:before,
.container:after {
  display: table;
  content: "";
  zoom: 1 /* ie fix */;
}

.container:after {
  clear: both;
}
.progress {
  width: 88px;
  height: 88px;
  background: none;
  position: relative;
}
.progress-text {
  font-size: 10px;
  font-weight: 500;
  color: #878787;
  line-height: 15px;
}
.progress::after {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 8px solid none;
  position: absolute;
  top: 0;
  left: 0;
}

.progress > span {
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 1;
}

.progress .progress-left {
  left: 0;
}

.progress .progress-bar {
  width: 100%;
  height: 100%;
  background: none;
  border-width: 8px;
  border-style: solid;
  position: absolute;
  top: 0;
}

.progress .progress-left .progress-bar {
  left: 100%;
  border-top-right-radius: 80px;
  border-bottom-right-radius: 80px;
  border-left: 0;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.progress .progress-right {
  right: 0;
}

.progress .progress-right .progress-bar {
  left: -100%;
  border-top-left-radius: 80px;
  border-bottom-left-radius: 80px;
  border-right: 0;
  -webkit-transform-origin: center right;
  transform-origin: center right;
}

.progress .progress-value {
  position: absolute;
  top: 0;
  left: 0;
}

.footer-tab {
  margin-left: 20px;
}
.border-primary {
  border-color: #48a0ff !important;
}
.ques-overflow-hide {
  overflow-x: unset;
}

.question-icon-panel {
  cursor: pointer;
  text-align: center;
}
.questions-seperator {
  border-bottom: 1px solid #b7b7b7;
  opacity: 0.25;
}
.feedback-form {
  .close {
    opacity: 1 !important;
  }
}
.mb-nav-icons {
  display: inline-block;
  position: absolute;
  right: 30px;
  max-width: 80px;
  padding-top: 6px !important;
}
.mb-prev-icon {
  padding-right: 10px;
  height: 35px;
  width: 35px;
  display: inline-block;
  img {
    height: 35px;
    width: 35px;
  }
}
.mb-next-icon {
  float: right;
  height: 35px;
  width: 35px;
  img {
    height: 35px;
    width: 35px;
  }
}
.question-info {
  position: relative;
}
.container-width {
  min-width: 95%;
}
.menu-width {
  max-width: 5%;
}
</style>
